export default "__VITE_ASSET__uxCCl2gY__"